/// <amd-module name="Build/Common/Artifacts/providers/Unknown" />
import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes } from 'Common';
export class Unknown extends Base {
    public getKey() {
        return BuildArtifactTypes.Unknown;
    }
}
